import { Injectable } from '@angular/core'
import { MbPaymentModeAdapter } from './mb-payment-mode.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbPaymentModeConnector {

  constructor (protected adapter: MbPaymentModeAdapter) {
  }

  get (cartID: string) {
    return this.adapter.load(cartID)
  }
}
